import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class AddressApiService {
  constructor(protected http: HttpClient) {}

  geocode(query: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/address/geocode?query=${query}`);
  }

  autocomplete(query: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/address/autocomplete?query=${query}`);
  }

  getCountries() {
    return this.http.get<any[]>(`${environment.apiUrl}/address/countries`);
  }

  getRegions(country: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/address/countries/${country}/regions`);
  }

  getCities(region: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/address/regions/${region}/cities`);
  }
}
